import { Text, colors, radii } from '@khaddi/ui';
import { View } from 'react-native';

export type InfoRow = { label: string; value: string };

export const InfoRows = ({ rows }: { rows: InfoRow[] }) => (
  <View style={{ backgroundColor: colors.surface, borderRadius: radii.lg, paddingHorizontal: 14, paddingVertical: 4 }}>
    {rows.map((row, index) => (
      <View
        key={row.label}
        style={{ flexDirection: 'row', alignItems: 'center', minHeight: 48, gap: 12, borderBottomWidth: index === rows.length - 1 ? 0 : 1, borderBottomColor: colors.divider, paddingVertical: 8 }}
      >
        <Text variant="caption" style={{ width: 110 }}>
          {row.label}
        </Text>
        <Text variant="bodyStrong" style={{ flex: 1, textAlign: 'right' }}>
          {row.value}
        </Text>
      </View>
    ))}
  </View>
);
